import { render, staticRenderFns } from "./YmPagination.vue?vue&type=template&id=5743ebbd&scoped=true&"
import script from "./YmPagination.vue?vue&type=script&lang=js&"
export * from "./YmPagination.vue?vue&type=script&lang=js&"
import style0 from "./YmPagination.vue?vue&type=style&index=0&id=5743ebbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5743ebbd",
  null
  
)

export default component.exports